import { Wordmark } from '@saniplus/ui';
import { useTranslation } from 'react-i18next';

/**
 * Shown while `bootstrapSession` decides whether there is a session.
 *
 * It carries the wordmark rather than a spinner: the first paint of a cold
 * start is the app saying which app it is, and a bare spinner on a black
 * screen at 21:55 reads as a phone that has hung.
 */
export function SplashScreen() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-canvas p-6"
    >
      <Wordmark label={t('app.brand')} size="md" product={t('app.product')} />
      <p className="text-support text-ink-muted">{t('app.loading')}</p>
    </div>
  );
}
